import React from 'react';
import Logo from '../../atoms/images/Logo'
import styles from './AuthMobile.module.scss';

export class AuthMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            version: this.props.version
        }
    }

    render() {
        const {
            content,
            version,
            title,
            handleGoBack
        } = this.props;
        const containerNameLogo = version === 'logo' ? styles['auth-mobile-container-logo'] : "";
        const containerNameHeader = version === 'header' ? styles['auth-mobile-container-header'] : '';
        return (
            <div className={
                styles["auth-mobile-container"] +
                (containerNameLogo ? ' ' + containerNameLogo : '') +
                (containerNameHeader ? ' ' + containerNameHeader : '')
            }>
                <div className={styles["header-container"]}>
                </div>
                <div className={styles["main"]}>
                    <div className={styles['placeholder']} onClick={handleGoBack} data-automation-id="go-back">
                        {this.state.version === 'logo' && <div className={styles["logo"]}>
                            <Logo white={true}></Logo>
                        </div>}

                        {this.state.version === 'header' && <div className={styles["header"]}>
                            {handleGoBack && <i className="icon icon-back"></i>}
                            <p className={styles['title']}>{title}</p>
                        </div>}
                    </div>
                    <div className={styles["content-container"]}>
                        {content}
                    </div>
                </div>
            </div>
        )
    }

}


AuthMobile.propTypes = {
    
};

export default AuthMobile;